import React, { useState, useEffect, createContext, useReducer, Reducer } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import CustomReactDatepickerInput from 'live/components/forms/ui/custom-react-datepicker-input'
import { HashRouter as Router, Route } from 'react-router-dom'
import LiveHeader from 'live/components/header/ui/main/main'
import Header from '../js/Form/components/Header/reportHeader'
import Body from '../js/Form/components/Body/index'

import Home from '../js/page/Home'
import { GeneralInformationSection } from '../js/page/settings/GeneralInformationSection'
import { RecipientGroupsSection } from '../js/page/settings/RecipientGroupsSection'
import Content from '../js/page/settings/Content'
import Preview from '../js/page/settings/Preview'

import init from '../js/init'
import Report from '../js/common/types/api/report'
import { ThemeProvider } from '@intelie/ui'
import liveTheme, { mergeIntelieUiTheme } from 'live/services/theme'
import { SchedulingSection } from '../js/page/settings/SchedulingSection'
import '../shared'

const App = ({ children, className }): JSX.Element => {
    const [top, setTop] = useState(0)

    useEffect(() => {
        setTop(document.querySelector('nav').getBoundingClientRect().height)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document.querySelector('nav')])

    return (
        <AppStyles className={className}>
            <LiveHeader />
            <div className={'inner-app'} style={{ top }}>
                {children}
            </div>
        </AppStyles>
    )
}
const AppStyles = styled.div`
    position: relative;
    height: 100%;

    .inner-app {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
`
export interface ContextReport {
    report: Report
    dispatch: (state: any) => void
}

const initContextReport = {
    report: undefined,
    dispatch: undefined
} as ContextReport

const ReportContext = createContext<ContextReport>(initContextReport)

function reducer(state, action) {
    return {
        ...state,
        ...action
    }
}

const ReportMaker = (): JSX.Element => {
    const [state, dispatch] = useReducer<Reducer<ContextReport, any>>(reducer, initContextReport)

    return (
        <ThemeProvider cssVarsSelector=":root" themeMerger={mergeWithLiveTheme}>

            <ReportContext.Provider value={{ ...state, dispatch }}>
                <Router>
                    <App>
                        <Route store={state} component={Header} />
                        <Body id="report-app-body">
                            <Route exact path="/" component={Home} />
                            <Route
                                path="/generalinformation/:uid"
                                render={routeProps => <GeneralInformationSection {...routeProps} dispatch={dispatch} />}
                            />
                            <Route
                                path="/recipientgroups/:uid"
                                render={routeProps => <RecipientGroupsSection {...routeProps} dispatch={dispatch} />}
                            />
                            <Route
                                path="/scheduling/:uid"
                                render={routeProps => <SchedulingSection {...routeProps} dispatch={dispatch} />}
                            />
                            <Route path="/content/:uid" render={routeProps => <Content {...routeProps} />} />
                            <Route path="/preview/:uid" render={routeProps => <Preview {...routeProps} />} />
                        </Body>
                    </App>
                </Router>
            </ReportContext.Provider>
        </ThemeProvider>
    )
}


const mergeWithLiveTheme = theme => {
    const merged = mergeIntelieUiTheme(theme, liveTheme)
    return merged
}

document.addEventListener('DOMContentLoaded', () => {
    if(location?.pathname?.includes('/app/reports_maker')){
        ReactDOM.render(<ReportMaker />, document.getElementById('main-content'))
        init()        
    }
    require('./registerAdminConfig')
})

export { ReportContext }
